import request from '../../libs/request';

export default {
  checkout: (cartId, token, siteId) => {
    return request(`api/v1/${siteId}/carrinho/checkout/${cartId}`).get({ token, throwError: true });
  },

  getPaymentTypes: (cartId, queryParams = {}, token, siteId) => {
    return request(`api/v1/${siteId}/carrinho/${cartId}/formasPagamento`).get({ queryParams, token, throwError: true });
  },

  validateCreditCard: (number, siteId) => {
    return request(`api/v1/${siteId}/cartaoCredito/${number}/bandeira`).get();
  },

  verifyCartIsFinalized: {
    get: (cartId, token, siteId) => {
      return request(`api/v1/${siteId}/carrinho/${cartId}/confirmacao`).get({ token, throwError: true });
    },
    post: (cartId, token, siteId) => {
      return request(`api/v1/${siteId}/carrinho/${cartId}/confirmacao`).post({ token, throwError: true });
    },
  },

  verifyUserRegistrationIsComplete: (customerId, token, siteId) => {
    return request(`api/v1/${siteId}/pessoa/${customerId}/valido`).get({
      queryParams: { checkout: true },
      token,
      throwError: true,
    });
  },

  setAddressToDelivery: (cartId, addressId, token, siteId, sellerId) => {
    return request(`api/v1/${siteId}/carrinho/checkout/${cartId}/address/${addressId}/${sellerId}`).get({
      token,
      throwError: true,
    });
  },

  sendPaymentOrder: (cartId, body = {}, token, siteId) => {
    return request(`api/v1/${siteId}/carrinho/${cartId}/finalizar`).post({
      body,
      token,
      throwError: true,
      timeout: 60000,
    });
  },

  createBillet: (siteId, hash, installment) =>
    request(`${siteId}/pedidoVenda/${hash}/boleto${installment ? `/${installment}` : ''}`, 'ocean').get(),

  depositAccounts: (dpId, token, siteId) =>
    request(`api/v1/${siteId}/contaCorrente/deposito/${dpId}`).get({ token, throwError: true }),

  pixPayment: (hash, token, siteId, queryParams) =>
    request(`${siteId}/pedidoVenda/${hash}/pix`, 'ocean').get({ queryParams, token, throwError: true }),
};
